import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 8F505717-7778-4909-81E9-0714F01B44AF
 * name checkbox-blank-off
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-off.svg
 * tags
 * - Form 
 */
export const CheckboxBlankOffIcon = createSvgIcon(<><path d="M20.84 22.73L19.1 21C19.06 21 19.03 21 19 21H5C3.9 21 3 20.11 3 19V5C3 4.97 3 4.94 3 4.9L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21 5C21 3.89 20.1 3 19 3H6.2L21 17.8V5Z" /></>, 'CheckboxBlankOffIcon');
export default CheckboxBlankOffIcon